/**
 * Redirects /c/:chapterSlug/m/messages (and its ?groups= query) to
 * /c/:chapterSlug/m/groups, preserving the search params so dashboard
 * "View All ?groups=all" links keep working.
 */

import { Navigate, useLocation, useParams } from 'react-router';

export function LegacyMessagesRedirect() {
  const params = useParams<{ chapterSlug?: string }>();
  const location = useLocation();
  const slug = params.chapterSlug ?? '96';
  return <Navigate to={`/c/${slug}/m/groups${location.search}`} replace />;
}

export default LegacyMessagesRedirect;
